import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

export async function submitLead(payload) {
  const res = await apiClient.post("/leads", payload);
  return res.data;
}

export default apiClient;
